export const sortFields = [
	'id',
	'materialTemplateRef',
	'propertyTypes',
	'createdAt',
	'updatedAt',
] as const;
